import React, { useState } from 'react';
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { COLOR_WHITE, LINEAR_GRADIENT_BG } from '../../const';
import { toast } from "react-toastify";
import { MSG_INTERNAL_ERROR } from '../../const/msg';

// Utility function to format number with commas
const formatNumber = (num) => {
    if (!num) return '';
    
    // If num is a string with non-numeric characters (except commas), just return it
    if (typeof num === 'string' && isNaN(num.replace(/,/g, ''))) {
        return num;
    }
    
    // Remove existing commas and format
    const value = typeof num === 'string' ? num.replace(/,/g, '') : num.toString();
    return value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

function PlusOptionModal({ showPlusStockModal, setShowPlusStockModal, plusStock, cartDatas, setCartDatas }) {
    // State
    const [isOption, setIsOption] = useState({
        name: '',
        price: 0
    });

    const handleSubmit = async () => {
        try {
            let { order, oIndex, cart, cIndex } = plusStock;
            // console.log("order, oIndex, cart, cIndex", order, oIndex, cIndex);
            let updateCartData = [...cartDatas];

            // Ensure the indices are valid and the structure exists
            if (updateCartData[cIndex] && updateCartData[cIndex].data?.orders[oIndex]) {
                if (!updateCartData[cIndex].data.orders[oIndex].options) {
                    updateCartData[cIndex].data.orders[oIndex].options = [isOption];
                } else {
                    updateCartData[cIndex].data.orders[oIndex].options = [...updateCartData[cIndex].data.orders[oIndex].options, isOption];
                }
                // join option name to product name
                const newOption =  updateCartData[cIndex].data.orders[oIndex].options;
                const optionName = newOption.map((n) => (`${n?.name} (${formatNumber(n?.price)})`)).join(', ');
                const optionPrice = newOption.reduce((sum, p) => sum + parseInt(p?.price || 0, 10), 0);
                const amount = parseInt(order?.amount || 0, 10);
                updateCartData[cIndex].data.orders[oIndex].productName = updateCartData[cIndex].data.orders[oIndex].productName.split("(")[0] + "(" + optionName + ")";
                updateCartData[cIndex].data.orders[oIndex].totalPrice = (amount * parseInt(order?.price || 0, 10)) + (optionPrice * amount); 

                // Update the state with the modified cart data
                setCartDatas(updateCartData);
            } else {
                console.error("Invalid indices or structure not found in cartDatas");
            }
            setShowPlusStockModal(false);
        } catch (error) {
            console.log("Error in handleSubmit...", error);
            toast.error(MSG_INTERNAL_ERROR);
        }
    };


    const onCloseFreeStatus = () => {
        setIsOption({});
        setShowPlusStockModal(false);
    }

    // Handle input change
    const handlePriceChange = (e) => {
        const value = e.target.value;
        
        // Remove commas for storing the actual number
        const numericValue = value.replace(/,/g, '');
        
        setIsOption((prev) => ({
            ...prev, 
            price: parseInt(numericValue || 0, 10)
        }));
    };

    return (
        <>
            <Modal
                show={showPlusStockModal}
            >
                <Modal.Header>
                    <h5>+ເພີ່ມອອບຊັນ {plusStock?.order?.productName ?? '...?'}</h5>
                </Modal.Header>
                <Modal.Body style={{ padding: "4em"}}>
                    {/* <Form onSubmit={handleSubmit}> */}
                        <Row style={{marginTop: "-3em"}}>
                            <Col>
                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label>ເບີ້ສີ</Form.Label>
                                <Form.Control 
                                    defaultValue="..."
                                    type="text" value={isOption?.name} 
                                    onChange={(e) => setIsOption((prev) => ({...prev, name: e?.target?.value }))}
                                />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label>ລາຄາ</Form.Label>
                                <Form.Control autoFocus type="text"
                                    placeholder="..."
                                    value={formatNumber(isOption?.price)}
                                    onChange={handlePriceChange} 
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <div className="d-flex gap-2 justify-content-end align-items-center mt-4">
                        <Button type="button" variant="light" onClick={onCloseFreeStatus}>
                            ຍົກເລີກ
                        </Button>
                        <Button onClick={handleSubmit} variant="light" style={{ background: LINEAR_GRADIENT_BG, color: COLOR_WHITE }}>
                            ຢືນຢັນ
                        </Button>
                        </div>
                    {/* </Form> */}
                </Modal.Body>
            </Modal>
        </>
    )
}

export default PlusOptionModal;